module.exports = __webpack_public_path__ + "img/GROZ BECKERT.ff979561.jpg";